import { UserStateModel } from './user.state'

export enum USER_ACTIONS {
	UPDATE = '[User] Update',
}

export namespace UserAction {
	export class Update {
		static readonly type = USER_ACTIONS.UPDATE
		constructor(public payload: Partial<UserStateModel>) {}
	}
}
